<template>
  <div>
    <van-nav-bar
      title="订单"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />

    <van-form >
      <van-field v-model="form.name"  label="客户名称" />

      <van-field name="radio" label="销售">
        <template #input>
          <van-radio-group v-model="form.saler" direction="horizontal">
           <van-radio :name="item.id" v-for="item in salers" :key="item.id">{{item.name}}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="type" label="客户类型">
        <template #input>
          <van-radio-group v-model="form.type" direction="horizontal">
           <van-radio name="团购" >团购</van-radio>
           <van-radio name="商超" >商超</van-radio>
           <van-radio name="二批" >二批</van-radio>
           <van-radio name="餐饮" >餐饮</van-radio>
           <van-radio name="其他" >其他</van-radio>

          </van-radio-group>
        </template>
      </van-field>
      <van-field name="sendtype" label="配送方式">
        <template #input>
          <van-radio-group v-model="form.send_type" direction="horizontal">
           <van-radio name="市区送货" >市区送货</van-radio>
           <van-radio name="物流" >物流</van-radio>
           <van-radio name="快递" >快递</van-radio>
           <van-radio name="客户自提" >客户自提</van-radio>
           <van-radio name="冷链" >冷链</van-radio>

          </van-radio-group>
        </template>
      </van-field>
      <van-field name="paytype" label="付款方式">
        <template #input>
          <van-radio-group v-model="form.pay_type" direction="horizontal">
           <van-radio name="预付款" >预付款</van-radio>
           <van-radio name="物流代收" >物流代收</van-radio>
           <van-radio name="月结" >月结</van-radio>
           <van-radio name="签字转账" >签字转账</van-radio>
           <van-radio name="货到付款" >货到付款</van-radio>
           <van-radio name="周结" >周结</van-radio>

          </van-radio-group>
        </template>
      </van-field>
<van-field v-model="form.lxr"  label="联系人" />
<van-field v-model="form.phone"  label="联系电话" />
<van-field v-model="form.address"  label="地址" />
      <div style="margin: 16px;">
        <van-button round block type="info"  @click="createclient">创建</van-button>
      </div>
    </van-form>




  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
import { Notify } from 'vant';
  export default {
    name: 'RukuList',
    data () {
      return {
        value:'',
        clients:[],
        inputtxt:'',
        saler:'',
        salers:[],
        form:{
          'name':'',
          'type':'',
          'paytype':'',
          'sendtype':'',
          'lxr':'',
          'phone':'',
          'saler':'',
          'team':1
        }





      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      this.getsaler()
    },
    methods:{
      getsaler(){
        let query = {
          limit:999,
          status:1
        }
        Api.GetUserList(query).then(res=>{
          this.salers = res.data.data
        })
      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },
      createclient(){
        Api.CreateClient(this.form).then(res=>{

          if (res.code=='4000'){
            console.log(res.code)
            Notify({ type: 'warning', message: res.msg });
          }else{
            Notify({ type: 'success', message: res.msg });
            this.$router.push({path:'/'})
          }

        })
      }




    }
  }

</script>

<style>
  .celllabel{
    width:100%
  }
</style>



// WEBPACK FOOTER //
// src/views/shangwuviews/clientadd/index.vue